const allLoggers = [];
const noOp = function () {};
let isLoggingGloballyDisabled = false;
let globalLogLevels = ['warn', 'error'];

/**
 * Creates a logger.
 * @param name (String) - The name of the class/file that defines the logger's context
 * @param isEnabled (Boolean) - Determines whether or not the logger is enabled. True by default. Can be overridden by
 *                              global isLoggingGloballyDisabled setting.
 * @param enabledLogLevels (Array) - List of log levels to spew. If supplied inherits from global. If not supplied
 *                                    inherits from global; if defined overrides global.
 * @returns {Logger}
 */
export function createLogger (name, enabledLogLevels = null, isEnabled = true) {
  const logger = new Logger({
    name,
    enabledLogLevels,
    isEnabled
  });

  allLoggers.push(logger);

  return logger;
}

// useful for unit testing to turn off all log levels
export function disableAllLoggers () { // TODO: Expose on WV API
  isLoggingGloballyDisabled = true;
  allLoggers.forEach(l => l.init());
}

export function setLogLevels (levels) { // TODO: Expose on WV API
  globalLogLevels = levels;
  allLoggers.forEach(l => l.init());
}

class Logger {
  __name;
  __isEnabled;
  __enabledLogLevels;

  constructor ({name, enabledLogLevels, isEnabled}) {
    this.__name = name;
    this.__isEnabled = isEnabled;
    this.__enabledLogLevels = enabledLogLevels;

    this.init();
  }

  init () {
    const console = window.console;
    const prefix = this.__name ? `${this.__name}: ` : '';
    const useLogger = !isLoggingGloballyDisabled && this.__isEnabled;
    const logLevels = this.__enabledLogLevels === null ? globalLogLevels : this.__enabledLogLevels;

    for (const method in console) {
      if (typeof console[method] === 'function') {
        this[method] = (useLogger && logLevels.includes(method)) ? console[method].bind(window.console, prefix) : noOp;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/logger.js